const aiChatHistoryStyles = {
  paper: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    width: "80%",
    overflowY: "auto",
  },
  container: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: "background.paper",
  },
};

export default aiChatHistoryStyles;
